import React from 'react';

import { Props as UseDataProps, useData as _useData } from './hooks/useData';

type Props = {
  /** For dependency injection testing only */
  useData?: () => ReturnType<typeof _useData>;
};

const BannerMessage = ({ useData = _useData }: Props = {}) => {
  const { bannerMessage, isLoading } = useData();

  return isLoading ? null : (
    <div
      dangerouslySetInnerHTML={{
        __html: bannerMessage,
      }}
    />
  );
};

BannerMessage.shouldRender = (props: UseDataProps = {}) =>
  _useData.call(this, props)?.shouldRender;

export { BannerMessage };
